<template>
  <div>
    <a ref="lienDownload"></a>
    <v-server-table url="" v-if="startRenderingTable"
      :columns="columns" :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"
        />
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <qd-checkbox v-model="props.row.selected"
                    @input="selectionRemiseBancaire()"
                    :class="{'disabled': !canDelete(props.row) }">
        </qd-checkbox>
      </div>
      <div slot="num" slot-scope="props" class="is-pulled-left">
        <router-link :to="{ name: getRouteNameDetail, params: {id: props.row.id}}"
                     :class="{'text-access-no-permission':
                                   !checkPermissions(permissions.lecture)}"
                     class="lien">
          {{ generationCodeRemiseBancaire(props.row.num, props.row.nom) }}
        </router-link>
      </div>
      <div slot="dateRemise" slot-scope="props" class="is-pulled-left">
        {{ props.row.dateRemise | formatDate }}
      </div>
      <div slot="etat" slot-scope="props" class="is-pulled-left">
        {{ changEtat(props.row.etat) }}
      </div>
      <div slot="montantTtc" slot-scope="props" class="is-pulled-right">
        {{ props.row.montantTtc | formatDevise}}
      </div>
      <div slot="exporter" slot-scope="props" >
        <a @click="checkPermissions(permissions.editer) ?
          edition({format: pdf,
                      typeDonnee: typeRemise}, props.row.id) : showPopUp()">
          <b-icon
            :key="props.id"
            icon="file-pdf-box"
            type="is-primary"
            :class="{'text-access-no-permission' : !checkPermissions(permissions.editer)}">
          </b-icon>
        </a>
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permissions.maj) ?
        $router.push({ name: getRouteNameEdition, params: {id: props.row.id}}) : showPopUp"
           :class="{'pointer-events-none' : props.row.etat === VALIDE}"
        >
          <b-icon icon="pencil-box-outline"
                  :class="{'text-access-no-permission':
                                   !checkPermissions(isSensAchat
                                   ? permissions.lecture : permissions.maj)
                                   || props.row.etat === VALIDE}"
                  type="is-success">
          </b-icon>
        </a>
      </div>
      <div slot="archive" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permissions.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permissions.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permissions.supprimer) ?
          openPopUpSuppression(props.row.id) : showPopUp()"
           :class="{'disabled': !canDelete(props.row)}">
          <b-icon icon="delete-forever"
                  :type="{'is-danger': canDelete(props.row) }"
                  :class="{'text-access-no-permission' :
            !checkPermissions(permissions.supprimer) && canDelete(props.row)}">
          </b-icon>
        </a>
      </div>
    </v-server-table>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-suppression
        :messHeader="$t('supprimerRemiseBancaire.delete')"
        :messFooter="$t('supprimerRemiseBancaire.irreversible')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteRemiseBancaire()">
      </pop-up-suppression>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  SENS_ACHAT, MODULE_GESTION_COMMERCIALE,
  MODULE_BAIL, MODULE_TLPE, MODULE_ACHAT,
} from '@/configuration/devisConf';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import formatCodeRemiseBancaire from '@/services/remiseBancaire/creationCodeRemiseBancaire';
import { VALIDE, ENCOURS, TYPE_EDITION_REMISE } from '@/configuration/remiseBancaire/remiseBancaireConf';
import popUpSuppression from '@/components/general/popUpPrevention';
import { remove } from '@/api/remiseBancaire/index';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import edition from '@/api/edition';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import inProgress from '@/services/general/inProgress';
import formatDate from '@/services/general/formatIsoDate';

const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const TableUserParam = createNamespacedHelpers('tableUserParam');

export default {
  name: 'remiseBancaireTable',
  props: {
    sens: {
      type: String,
      required: true,
    },
    referenceTable: {
      type: String,
      required: true,
    },
    permissions: {
      type: Object,
      required: true,
    },
    moduleDcf: {
      type: String,
      required: false,
      default: MODULE_GESTION_COMMERCIALE,
    },
    nameStore: {
      type: String,
      required: false,
      default: 'remiseBancaire',
    },
  },
  data() {
    return {
      remiseBancaireSelected: false,
      VALIDE: VALIDE,
      popUpSuppression: false,
      remiseIdToDelete: null,
      pdf: TYPE_PDF,
      typeRemise: TYPE_EDITION_REMISE,
      allRemiseBancaireSelected: false,
      resultPerPage: RESULTS_PER_PAGE,
      startRenderingTable: false,
    };
  },
  components: {
    TableItemsInView,
    popUpSuppression,
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async deleteRemiseBancaire() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await remove(this.remiseIdToDelete);
        messageSucces(this.$t('remiseBancaire.remisebancaireSupprime'));
        this.popUpSuppression = false;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    openPopUpSuppression(remiseId) {
      this.remiseIdToDelete = remiseId;
      this.popUpSuppression = true;
    },
    generationCodeRemiseBancaire(num, name) {
      return formatCodeRemiseBancaire(num, name, this.sens);
    },
    changEtat(etat) {
      return etat === 'EnCours' ? this.$t('remiseBancaire.dataTable.enCours') : this.$t('remiseBancaire.dataTable.valide');
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    selectionRemiseBancaire() {
      this.remiseBancaireSelected = this.remiseBancaires.filter((el) => {
        return el.selected;
      }).length > 0;
    },
    canDelete(remiseBancaire) {
      if (this.isSensAchat) return true;
      return remiseBancaire.etat === ENCOURS && remiseBancaire.montantTtc === 0
        && remiseBancaire.nbReglements === 0;
    },
    selectAll() {
      const selected = !this.allRemiseBancaireAreSelected;
      this.remiseBancaires.forEach((el) => {
        if (this.canDelete(el)) el.selected = selected;
      });
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    async edition(donnees, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...TableUserParam.mapGetters({
      tableUserParam: 'tableUserParam',
    }),
    critereRechercheRemiseBancaire() {
      return this.$store.getters[`${this.nameStore}/critereRechercheRemiseBancaire`];
    },
    critereRechercheLotPaiement() {
      return this.$store.getters[`${this.nameStore}/critereRechercheLotPaiement`];
    },
    remiseBancaires() {
      return this.$store.getters[`${this.nameStore}/items`];
    },
    total() {
      return this.$store.getters[`${this.nameStore}/total`];
    },
    allRemiseBancaireAreSelected() {
      const allRemisesCanDelete = this.remiseBancaires.filter((remise) => {
        return this.canDelete(remise);
      });
      return !!(this.remiseBancaires.length
        && !allRemisesCanDelete.some(remise => !remise.selected));
    },
    getRouteNameDetail() {
      if (this.moduleDcf === MODULE_BAIL) return 'c.baux.lot_paiement';
      if (this.moduleDcf === MODULE_TLPE) return 'c.gabed.lot_paiement_recette';
      if (this.moduleDcf === MODULE_ACHAT) return 'c.achat.lot_paiements_factures';
      return 'c.bodac.remises_bancaires';
    },
    getRouteNameEdition() {
      if (this.moduleDcf === MODULE_BAIL) return 'm.baux.lot_paiement';
      if (this.moduleDcf === MODULE_TLPE) return 'm.gabed.lot_paiement_recette';
      if (this.moduleDcf === MODULE_ACHAT) return 'm.achat.lot_paiements_factures';
      return 'm.bodac.remises_bancaires-editionRemise';
    },
    isSensAchat() {
      return this.sens === SENS_ACHAT;
    },
    iconSelectTotal() {
      if (this.allRemiseBancaireAreSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      const columns = ['selected', 'num', 'nom', 'dateRemise', 'modeReglement.libelle', 'etat', 'remiseEffet', 'domiciliationBancaire.libelle', 'nbReglements', 'montantTtc', 'edit', 'archive'];
      if (!this.isSensAchat) {
        columns.splice(columns.findIndex((column) => column === 'edit'), 0, 'exporter');
        columns.push('delete');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          nom: this.$i18n.t('remiseBancaire.dataTable.nom'),
          'modeReglement.libelle': this.isSensAchat ? this.$i18n.t('listeLotPaiement.dataTable.modePaiement') : this.$i18n.t('remiseBancaire.dataTable.modeReglement'),
          num: this.isSensAchat ? this.$i18n.t('listeLotPaiement.dataTable.num') : this.$i18n.t('remiseBancaire.dataTable.num'),
          dateRemise: this.$i18n.t('remiseBancaire.dataTable.date'),
          'domiciliationBancaire.libelle': this.$i18n.t('remiseBancaire.dataTable.banque'),
          etat: this.$i18n.t('remiseBancaire.dataTable.etat'),
          remiseEffet: this.$i18n.t('remiseBancaire.dataTable.remiseEffet'),
          nbReglements: this.isSensAchat ? this.$i18n.t('listeLotPaiement.dataTable.nbPaiement') : this.$i18n.t('remiseBancaire.dataTable.nbReglement'),
          montantTtc: this.$i18n.t('remiseBancaire.dataTable.montant'),
          edit: '',
          delete: '',
          archive: '',
          exporter: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['nom', 'dateRemise', 'modeReglement.libelle'],
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          exporter: 'colonneSelected',
          delete: 'colonneSelected',
          archive: 'colonneSelected',
        },
        requestFunction: ((data) => {
          if (this.sens === SENS_ACHAT) data.query = cloneDeep(this.critereRechercheLotPaiement);
          else data.query = cloneDeep(this.critereRechercheRemiseBancaire);
          if (data.query.datesRemise) {
            data.query.datesRemise.dateDebut = formatDate(data.query.datesRemise.dateDebut);
            data.query.datesRemise.dateFin = formatDate(data.query.datesRemise.dateFin);
          }
          data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          data.query.sens = this.sens;
          data.query.societeId = this.societeActiveId;
          return this.$store.dispatch(`${this.nameStore}/loadRemiseBancaire`, data);
        }),
        responseAdapter: (() => {
          return {
            data: this.remiseBancaires,
            count: this.total,
          };
        }),
      };
    },
  },
  mounted() {
    this.resultPerPage = this.tableUserParam[this.referenceTable]?.nbResultatParPage
      || RESULTS_PER_PAGE;
    this.startRenderingTable = true;
  },
};
</script>

<style scoped>

</style>
